export default "__VITE_ASSET__B_SzdJ$P__"